import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

const styles = makeStyles(({ spacing, palette }) => ({
  wrapper: {
    padding: spacing(1.5),
    border: `1px solid ${grey[500]}`,
    gap: spacing(1),
    borderRadius: spacing(1),
    background: "none",
    textTransform: "none",
    alignItems: "center",
    height: 48,
    maxHeight: 48,
    cursor: "pointer",
  },
  active: {
    border: `1px solid ${palette.primary.main}`,
  },
  label: {
    lineHeight: 1,
    color: palette.paymentName.main,
  },
  activeLabel: {
    color: palette.primary.main,
  },
}));

export default styles;
